import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { useEffect } from "react";
import LanguageProcessModal from "./LanguageProcessModal";

const ITEM_HEIGHT = 45;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxWidth: ITEM_HEIGHT + ITEM_PADDING_TOP,
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "auto"
    }
  },
  // getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

const LanguageSettings = (props) => {
  const { multiLanguageData, selectedLanguage } = useSelector((state) => state.main);

  const { languageCode, setLanguageCode } = props;
  const LanguageData = multiLanguageData?.Settings || {};

  const {
    TEXT_LANGUAGE_SETTINGS = English.Settings.TEXT_LANGUAGE_SETTINGS,
    TEXT_LANGUAGES = English.Settings.TEXT_LANGUAGES,
    TEXT_CURRENT_LANGUAGE = English.Settings.TEXT_CURRENT_LANGUAGE,
    TEXT_PROCEED = English.Settings.TEXT_PROCEED
  } = LanguageData;

  const labelArray = [
    { language: "English", code: "en" },
    { language: "Hindi", code: "hi" },
    { language: "French", code: "fr" },
    { language: "Spanish", code: "es" },
    { language: "Afrikaans", code: "af" }
  ];

  const handleChange = (event) => {
    setLanguageCode(event.target.value);
  };

  useEffect(() => {
    setLanguageCode(selectedLanguage);
  }, []);

  return (
    <>
      <Modal open={props?.open}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6">{TEXT_LANGUAGE_SETTINGS}</Typography>
            <Stack flexDirection={"row"}>
              <IconButton onClick={() => props?.handleClose()}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </Box>
          <Box
            sx={{
              height: "350px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between"
            }}>
            <Stack spacing={2}>
              <Typography variant="h6" fontWeight={"bold"}>
                {" "}
                {TEXT_CURRENT_LANGUAGE}
              </Typography>
              <FormControl fullWidth>
                <InputLabel>{TEXT_LANGUAGES}</InputLabel>
                <Select
                  MenuProps={MenuProps}
                  value={languageCode}
                  onChange={handleChange}
                  label={TEXT_LANGUAGES}>
                  {labelArray.map((lang) => (
                    <MenuItem key={lang.code} value={lang.code}>
                      {lang.language}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Button
              sx={{ backgroundColor: "#ffbc0a", fontWeight: "bold" }}
              onClick={() => {
                props?.handleLanguageChange(languageCode);
                props?.setOpenProcessModal(true);
              }}
              loading={props?.isLoading}
              variant="contained"
              fullWidth>
              {TEXT_PROCEED}
            </Button>
          </Box>

          {props?.openProcessModal && <LanguageProcessModal open={props?.openProcessModal} />}
        </Box>
      </Modal>
    </>
  );
};

export default LanguageSettings;
